export function errorMessage(error: any) {
  return error?.response?.data?.message || error?.response?.data || error?.message || error
}
